import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db1dbea2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"90vh"} }
const _hoisted_2 = { style: {"height":"0.5vh","background-color":"#ccc"} }
const _hoisted_3 = { class: "p-mt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px"},
  class: "pi pi-arrow-right-arrow-left"
}, null, -1))
const _hoisted_5 = { class: "p-mx-1" }
const _hoisted_6 = {
  class: "p-col-12",
  style: {"height":"8vh"}
}
const _hoisted_7 = { class: "p-grid" }
const _hoisted_8 = { class: "p-col-9 p-pr-0" }
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "p-mr-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" NAME: ")
const _hoisted_12 = { class: "p-mr-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" BATCH: ")
const _hoisted_14 = {
  key: 0,
  class: "p-mr-2"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" REF: ")
const _hoisted_16 = {
  key: 1,
  class: "p-mr-2",
  style: {"color":"#ef4444"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "UNAVAILABLE (EXPIRED)", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "p-mr-2",
  style: {"color":"#ef4444"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "UNAVAILABLE (OUT OF STOCK)", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "p-mr-2" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" GENERIC: ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" AVAILABLE: ")
const _hoisted_25 = { class: "p-mr-2" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" PURCHASE PRICE: ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" EXPIRY: ")
const _hoisted_28 = { class: "p-col-3" }
const _hoisted_29 = { class: "p-fluid" }
const _hoisted_30 = {
  class: "p-col-12 pos-table",
  style: {"height":"64vh","background-color":"#f9f9f9","overflow-y":"auto"}
}
const _hoisted_31 = { class: "p-px-2" }
const _hoisted_32 = { class: "table table-stiped table-bordered p-m-0" }
const _hoisted_33 = { class: "pos-heading" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"16rem"} }, "Product Name", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8rem"} }, "Batch No", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"6rem"} }, "Available", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10rem"} }, "Transfer Qty *", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Paid Qty", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Free Qty", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Purchase Price", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Expiry", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "REMOVE", -1))
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "8",
  class: "p-text-center p-p-3",
  style: {"color":"#9ca3af"}
}, " No items added yet. ", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "table-row" }
const _hoisted_47 = { class: "p-inputgroup" }
const _hoisted_48 = { class: "p-inputgroup" }
const _hoisted_49 = { class: "p-inputgroup" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 1,
  style: {"color":"#9ca3af","font-size":"0.8rem"}
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 1,
  style: {"color":"#9ca3af","font-size":"0.8rem"}
}
const _hoisted_54 = { class: "p-text-center" }
const _hoisted_55 = { class: "p-text-center" }
const _hoisted_56 = { class: "item-detail-row" }
const _hoisted_57 = { colspan: "8" }
const _hoisted_58 = { class: "p-mr-2" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" PRODUCT: ")
const _hoisted_60 = { class: "heighlighted-green" }
const _hoisted_61 = { class: "p-mr-2" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" GENERIC: ")
const _hoisted_63 = { class: "heighlighted-green" }
const _hoisted_64 = { class: "p-mr-2" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" AVAILABLE: ")
const _hoisted_66 = { class: "heighlighted-green" }
const _hoisted_67 = { class: "p-mr-2" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" TRANSFER QTY: ")
const _hoisted_69 = { class: "heighlighted-green" }
const _hoisted_70 = { class: "p-mr-2" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" AMOUNT: ")
const _hoisted_72 = { class: "heighlighted-green" }
const _hoisted_73 = {
  class: "p-col-12",
  style: {"height":"10vh","background-color":"#eee"}
}
const _hoisted_74 = { class: "p-grid" }
const _hoisted_75 = { class: "p-col-9 p-pr-0" }
const _hoisted_76 = { class: "p-fluid" }
const _hoisted_77 = { class: "p-col-3" }
const _hoisted_78 = { style: {"padding":"8px","font-size":"0.85rem","color":"#374151","line-height":"1.8"} }
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" To: ")
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = {
  style: {"height":"10vh"},
  class: "p-grid p-m-0 p-p-0"
}
const _hoisted_82 = { class: "set-bottom-amt p-col" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" Items ")
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_85 = { class: "set-bottom-amt p-col" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" Total Amount ")
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_88 = { class: "confirmation-content" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem","color":"#e67e22"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.progressBar)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              style: {"height":"0.2em"}
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Toolbar, { style: {"height":"7.5vh"} }, {
        start: _withCtx(() => [
          _createElementVNode("h5", _hoisted_3, [
            _createElementVNode("b", null, [
              _hoisted_4,
              _createTextVNode(" Create Stock Transfer - " + _toDisplayString(_ctx.storeName), 1)
            ])
          ])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              label: "Clear All",
              class: "p-button-danger",
              onClick: _ctx.clearBasket
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_AutoComplete, {
                delay: 500,
                minLength: 2,
                onItemSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addFromAutoComplete($event))),
                scrollHeight: "500px",
                modelValue: _ctx.searchKeyword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchKeyword) = $event)),
                suggestions: _ctx.searchResults,
                autoHighlight: true,
                placeholder: " SEARCH PRODUCT NAME, BATCH NO, BARCODE, REFERENCE...",
                onComplete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchStock($event))),
                dropdown: false,
                id: "transfer-search-input",
                autoFocus: ""
              }, {
                item: _withCtx((slotProps) => [
                  _createElementVNode("div", {
                    style: _normalizeStyle(slotProps.item.is_unavailable ? 'opacity:0.55;' : '')
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("b", null, _toDisplayString(slotProps.item.product_name?.toUpperCase()), 1)
                      ]),
                      _createElementVNode("span", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("b", null, _toDisplayString(slotProps.item.batch_no), 1)
                      ]),
                      (slotProps.item.reference)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("b", null, _toDisplayString(slotProps.item.reference), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (slotProps.item.is_expired)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _hoisted_18))
                        : (slotProps.item.is_out_of_stock)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_21))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("b", null, _toDisplayString((slotProps.item.generic_name ?? slotProps.item.generic ?? '').toUpperCase()), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", {
                        class: "p-mr-2",
                        style: _normalizeStyle(slotProps.item.is_out_of_stock ? 'color:#ef4444;' : '')
                      }, [
                        _hoisted_24,
                        _createElementVNode("b", null, _toDisplayString(Number(slotProps.item.qty).toFixed(0)), 1)
                      ], 4),
                      _createElementVNode("small", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("b", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.item.purchase_price), 1)
                      ]),
                      _createElementVNode("small", {
                        class: "p-mr-2",
                        style: _normalizeStyle(slotProps.item.is_expired ? 'color:#ef4444;' : '')
                      }, [
                        _hoisted_27,
                        _createElementVNode("b", null, _toDisplayString(_ctx.formatExpiry(slotProps.item.expiry_date)), 1)
                      ], 4)
                    ])
                  ], 4)
                ]),
                _: 1
              }, 8, ["modelValue", "suggestions"])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.toBranchId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.toBranchId) = $event)),
                options: _ctx.branchList,
                optionLabel: "name",
                optionValue: "id",
                placeholder: "Select Destination Branch *",
                filter: true,
                class: _normalizeClass({ 'p-invalid': _ctx.itemBasket.length > 0 && !_ctx.toBranchId })
              }, null, 8, ["modelValue", "options", "class"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("table", _hoisted_32, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_33, [
                _hoisted_34,
                _hoisted_35,
                _hoisted_36,
                _hoisted_37,
                _hoisted_38,
                _hoisted_39,
                _hoisted_40,
                _createElementVNode("th", null, "Amount (" + _toDisplayString(_ctx.currency) + ")", 1),
                _hoisted_41,
                _hoisted_42
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.itemBasket.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_43, _hoisted_45))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemBasket.slice().reverse(), (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.stock_id
                }, [
                  _createElementVNode("tr", _hoisted_46, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_InputText, {
                          style: {"height":"30px"},
                          value: item.product_name,
                          disabled: true,
                          class: "p-p-1"
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_InputText, {
                          style: {"height":"30px"},
                          value: item.batch_no,
                          disabled: true,
                          class: "p-p-0"
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(Number(item.available_qty).toFixed(0)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_Button, {
                          icon: "pi pi-plus",
                          class: "p-button-success p-p-0",
                          onClick: ($event: any) => (_ctx.adjustQty('add', item))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_InputText, {
                          style: {"width":"3rem","height":"35px"},
                          value: item.qty,
                          id: 'transfer-qty-' + item.stock_id,
                          autocomplete: "off",
                          onInput: e => _ctx.onQtyInput(item, e),
                          class: _normalizeClass(["p-p-0 p-m-0", { 'is-invalid': !!item.qtyError }])
                        }, null, 8, ["value", "id", "onInput", "class"]),
                        _createVNode(_component_Button, {
                          icon: "pi pi-minus",
                          class: "p-button-warning p-p-0",
                          onClick: ($event: any) => (_ctx.adjustQty('minus', item))
                        }, null, 8, ["onClick"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      (item.paid_qty != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(Number(item.paid_qty).toFixed(0)), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_51, "-"))
                    ]),
                    _createElementVNode("td", null, [
                      (item.free_qty != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(Number(item.free_qty).toFixed(0)), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_53, "-"))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.purchase_price), 1),
                    _createElementVNode("td", _hoisted_54, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.fixDigits((item.paid_qty !== null ? item.paid_qty : (item.qty || 0)) * item.purchase_price)), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatExpiry(item.expiry_date)), 1),
                    _createElementVNode("td", _hoisted_55, [
                      _createVNode(_component_Button, {
                        icon: "pi pi-minus",
                        class: "p-button-danger p-p-1",
                        onClick: ($event: any) => (_ctx.removeFromBasket(item.stock_id))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_56, [
                    _createElementVNode("td", _hoisted_57, [
                      _createElementVNode("span", _hoisted_58, [
                        _hoisted_59,
                        _createElementVNode("span", _hoisted_60, _toDisplayString(item.product_name), 1)
                      ]),
                      _createElementVNode("span", _hoisted_61, [
                        _hoisted_62,
                        _createElementVNode("span", _hoisted_63, _toDisplayString(item.generic_name), 1)
                      ]),
                      _createElementVNode("span", _hoisted_64, [
                        _hoisted_65,
                        _createElementVNode("span", _hoisted_66, _toDisplayString(Number(item.available_qty).toFixed(0)), 1)
                      ]),
                      _createElementVNode("span", _hoisted_67, [
                        _hoisted_68,
                        _createElementVNode("span", _hoisted_69, _toDisplayString(Number(item.qty).toFixed(0)), 1)
                      ]),
                      _createElementVNode("span", _hoisted_70, [
                        _hoisted_71,
                        _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits((item.paid_qty !== null ? item.paid_qty : (item.qty || 0)) * item.purchase_price)), 1)
                      ])
                    ])
                  ])
                ], 64))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createVNode(_component_InputText, {
                placeholder: "Transfer Notes / Description",
                modelValue: _ctx.notes,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.notes) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("b", null, _toDisplayString(_ctx.selectedBranchName || '-'), 1),
              _hoisted_80
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_81, [
      _createVNode(_component_Button, {
        class: "p-col p-button-success b-style",
        icon: "pi pi-home",
        label: "HOME",
        onClick: _ctx.redirectHome
      }, null, 8, ["onClick"]),
      _createElementVNode("span", _hoisted_82, [
        _hoisted_83,
        _hoisted_84,
        _createTextVNode("# " + _toDisplayString(_ctx.itemBasket.length), 1)
      ]),
      _createElementVNode("span", _hoisted_85, [
        _hoisted_86,
        _hoisted_87,
        _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.basketTotalCost)), 1)
      ]),
      _createVNode(_component_Button, {
        class: "p-col p-button-warning b-style",
        icon: "pi pi-send",
        label: "SUBMIT (*)",
        onClick: _ctx.submitTransfer,
        disabled: _ctx.itemBasket.length === 0 || !_ctx.toBranchId || _ctx.hasAnyError
      }, null, 8, ["onClick", "disabled"])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.validationPopup,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.validationPopup) = $event)),
      style: { width: '700px' },
      header: "Notice"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Close",
          icon: "pi pi-times",
          class: "p-button-danger",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validationPopup = false)),
          autoFocus: ""
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_88, [
          _hoisted_89,
          _createElementVNode("span", null, _toDisplayString(_ctx.validationPopupMessage), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}